"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alertFragmentDependencies = exports.alertFragment = void 0;
const filterFragment_1 = require("./filterFragment");
const sourceGroupFragment_1 = require("./sourceGroupFragment");
const targetGroupFragment_1 = require("./targetGroupFragment");
exports.alertFragment = `
fragment alertFragment on Alert {
  id
  groupName
  name
  filterOptions
  filter {
    ...filterFragment
  }
  sourceGroup {
    ...sourceGroupFragment
  }
  targetGroup {
    ...targetGroupFragment
  }
}
`.trim();
exports.alertFragmentDependencies = [
    ...sourceGroupFragment_1.sourceGroupFragmentDependencies,
    ...filterFragment_1.filterFragmentDependencies,
    ...targetGroupFragment_1.targetGroupFragmentDependencies,
    sourceGroupFragment_1.sourceGroupFragment,
    filterFragment_1.filterFragment,
    targetGroupFragment_1.targetGroupFragment,
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWxlcnRGcmFnbWVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL2xpYi9mcmFnbWVudHMvYWxlcnRGcmFnbWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxxREFBOEU7QUFDOUUsK0RBRytCO0FBQy9CLCtEQUcrQjtBQUVsQixRQUFBLGFBQWEsR0FBRzs7Ozs7Ozs7Ozs7Ozs7OztDQWdCNUIsQ0FBQyxJQUFJLEVBQUUsQ0FBQztBQUVJLFFBQUEseUJBQXlCLEdBQUc7SUFDdkMsR0FBRyxxREFBK0I7SUFDbEMsR0FBRywyQ0FBMEI7SUFDN0IsR0FBRyxxREFBK0I7SUFDbEMseUNBQW1CO0lBQ25CLCtCQUFjO0lBQ2QseUNBQW1CO0NBQ3BCLENBQUMifQ==